/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Sub_Addons_Pages_Confirm_Downgrade_Desc_RemoveInputs */



/**
* | output |
* | --- |
* | "Your pages add-on will be removed on {date}. You keep your current pages until then." |
*
* @param {Sub_Addons_Pages_Confirm_Downgrade_Desc_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_pages_confirm_downgrade_desc_remove = /** @type {((inputs: Sub_Addons_Pages_Confirm_Downgrade_Desc_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Pages_Confirm_Downgrade_Desc_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihr Seiten-Add-on wird am ${i?.date} entfernt. Bis dahin behalten Sie Ihre aktuellen Seiten.`)
	return /** @type {LocalizedString} */ (`Your pages add-on will be removed on ${i?.date}. You keep your current pages until then.`)
});